/*global chrome*/
export const msalConfig = {
    auth: {
        clientId: process.env.REACT_APP_MICROSOFT_CLIENT_ID, // Replace 
        authority: 'https://login.microsoftonline.com/common',
        redirectUri: 'https://ms-app.liznr.ai/', // Replace with your redirect URI
        // redirectUri: chrome.identity.getRedirectURL(), // Replace with your redirect URI
        
    }
};